import React from "react";
import {
  Card,
  Heading,
  Box,
  Flex,
  Button,
  Link,
  Paragraph,
  Label,
  Image,
} from "theme-ui";
import { useLiquity } from "../../hooks/LiquityContext";
import { Icon } from "../../components/Icon";
import { toast } from "react-toastify";

import INCicon from "../../assets/icons/INC.png";
import PRINTicon from "../../assets/icons/PRINTtoken.png";
import INCDicon from "../../assets/icons/INCDtoken.png";

const piteasLink = (tokenAddress: string) =>
  `https://app.piteas.io/#/swap?inputCurrency=PLS&outputCurrency=${tokenAddress}`;
const portalXLink = (tokenAddress: string) =>
  `https://portalxswap.io/?fromChain=PULSECHAIN&toChain=PULSECHAIN&from=PLS&to=${tokenAddress}`;
const pulseXLink = (token0: string, token1: string) =>
  `https://pulsex.mypinata.cloud/ipfs/bafybeidea3ibq4lu5t6vk6ihp4iuznjb3ltsdm5y2shv4atxgyd3d33aim/#/add/V2/${token0}/${token1}`;

// add token to wallet
const addTokenToWallet = (
  tokenSymbol: string,
  tokenAddress: string,
  tokenImage: string
) => async () => {
  if (window.ethereum) {
    try {
      const { ethereum } = window as any;
      let url = "";

      if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        url = `http://localhost:3000/`;
      } else {
        url = `https://dev.d3t4kuh2evv701.amplifyapp.com/`;
      }

      await ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: tokenAddress,
            symbol: tokenSymbol,
            decimals: 18,
            image: url + tokenImage,
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
  }
};

export const TradingPair: React.FC = () => {
  const {
    liquity: {
      connection: { addresses },
    },
  } = useLiquity();

  const daiAddress = "0xefD766cCb38EaF1dfd701853BFCe31359239F305";

  const copyClipboard = (currency: any, address: any) => {
    navigator.clipboard.writeText(address);
    toast.success(`${currency} Address Copied!`, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  };

  return (
    <>
      <Card>
        <Heading>
          Trading Pair
          <Flex sx={{ justifyContent: "flex-end" }}>
            {/* <RemainingLQTY /> */}
          </Flex>
        </Heading>
        <Box sx={{ p: [2, 3] }}>
          <Paragraph>
            Use the below buttons to buy $PRINT & add liquidity on PulseX.
          </Paragraph>

          <Box sx={{ p: [1, 2] }}>
            <Flex
              sx={{
                alignItems: "stretch",
                justifyContent: "space-between",
                p: [1, 2],
              }}
            >
              <Flex
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                <Image
                  sx={{ width: 20, height: 20, cursor: "pointer", mr: 1 }}
                  src={INCDicon}
                  variant="avatar"
                />
                Buy INCD
              </Flex>

              <Flex
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                {/* <Link href={piteasLink(addresses["lusdToken"])} target="_blank" paddingRight={12}>
                Buy on Piteas <Icon name="external-link-alt" size="xs" />
              </Link> */}
                <Link
                  href={piteasLink(addresses["lusdToken"])}
                  target="_blank"
                >
                  Buy on Piteas <Icon name="external-link-alt" size="xs" />
                </Link>
              </Flex>
            </Flex>

            <Flex
              sx={{
                alignItems: "stretch",
                justifyContent: "space-between",
                p: [1, 2],
              }}
            >
              <Flex
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                <Image
                  sx={{ width: 20, height: 20, cursor: "pointer", mr: 1 }}
                  src={PRINTicon}
                  variant="avatar"
                />{" "}
                Buy PRINT
              </Flex>
              <Flex
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                {/* <Link href={piteasLink(addresses["lqtyToken"])} target="_blank" paddingRight={12}>
                Buy on Piteas <Icon name="external-link-alt" size="xs" />
              </Link> */}
                <Link
                  href={piteasLink(addresses["lqtyToken"])}
                  target="_blank"
                >
                  Buy on Piteas <Icon name="external-link-alt" size="xs" />
                </Link>
              </Flex>
            </Flex>

            <Flex
              sx={{
                alignItems: "stretch",
                justifyContent: "space-between",
                p: [1, 2],
              }}
            >
              <Flex
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                <Image
                  sx={{ width: 20, height: 20, cursor: "pointer" }}
                  src={INCDicon}
                  variant="avatar"
                />
                <Image
                  sx={{ width: 20, height: 20, cursor: "pointer", mr: 1 }}
                  src={INCicon}
                  variant="avatar"
                />
                Add INCD-DAI Pair
              </Flex>
              <Link
                href={pulseXLink(addresses["lusdToken"], daiAddress)}
                target="_blank"
              >
                Add on PulseX <Icon name="external-link-alt" size="xs" />
              </Link>
              {/* <Button>Buy</Button> */}
            </Flex>

            <Flex
              sx={{
                alignItems: "stretch",
                justifyContent: "space-between",
                p: [1, 2],
              }}
            >
              <Flex
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                <Image
                  sx={{ width: 20, height: 20, cursor: "pointer" }}
                  src={PRINTicon}
                  variant="avatar"
                />
                <Image
                  sx={{ width: 20, height: 20, cursor: "pointer", mr: 1 }}
                  src={INCicon}
                  variant="avatar"
                />
                Add PRINT-INC Pair
              </Flex>
              <Link
                href={pulseXLink(addresses["plxToken"], addresses["lqtyToken"])}
                target="_blank"
              >
                Add on PulseX <Icon name="external-link-alt" size="xs" />
              </Link>
            </Flex>
          </Box>
        </Box>
      </Card>

      <Card>
        <Heading>
          Metamask Features
          <Flex sx={{ justifyContent: "flex-end" }}>
            {/* <RemainingLQTY /> */}
          </Flex>
        </Heading>
        <Box sx={{ p: [2, 3] }}>
          <Paragraph sx={{}}>
            Use the below features to add the tokens used in INC Printer to your
            MetaMask wallet. You will be able to see the balance by adding the
            tokens to your wallet.
          </Paragraph>

          <Box sx={{ p: [1, 2] }}>
            <Flex
              sx={{
                alignItems: "stretch",
                justifyContent: "space-between",
                p: [1, 2],
              }}
            >
              <Flex
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                <Image
                  sx={{ width: 20, height: 20, cursor: "pointer", mr: 1 }}
                  src={INCicon}
                  variant="avatar"
                />
                Add INC asset to wallet
              </Flex>
              <Flex
                sx={{ alignItems: "stretch", justifyContent: "space-between" }}
              >
                <Heading
                  sx={{ fontSize: 1, pr: [1, 2] }}
                  onClick={() => copyClipboard("INC", addresses["plxToken"])}
                >
                  <Icon name="clipboard" size="2x" />
                </Heading>
                <Button
                  onClick={addTokenToWallet(
                    "INC",
                    addresses["plxToken"],
                    INCicon
                  )}
                  sx={{ height: "30px", width: "70px" }}
                >
                  Add
                </Button>
              </Flex>
            </Flex>

            <Flex
              sx={{
                alignItems: "stretch",
                justifyContent: "space-between",
                p: [1, 2],
              }}
            >
              <Flex
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                <Image
                  sx={{ width: 20, height: 20, cursor: "pointer", mr: 1 }}
                  src={INCDicon}
                  variant="avatar"
                />
                Add INCD asset to wallet
              </Flex>
              <Flex
                sx={{ alignItems: "stretch", justifyContent: "space-between" }}
              >
                <Heading
                  sx={{ fontSize: 1, pr: [1, 2] }}
                  onClick={() =>
                    copyClipboard("INCD", addresses["lusdToken"])
                  }
                >
                  <Icon name="clipboard" size="2x" />
                </Heading>
                <Button
                  onClick={addTokenToWallet(
                    "INCD",
                    addresses["lusdToken"],
                    INCDicon
                  )}
                  sx={{ height: "30px", width: "70px" }}
                >
                  Add
                </Button>
              </Flex>
            </Flex>

            <Flex
              sx={{
                alignItems: "center",
                justifyContent: "space-between",
                p: [1, 2],
              }}
            >
              <Flex sx={{ alignItems: "center", justifyContent: "center" }}>
                <Image
                  sx={{ width: 20, height: 20, cursor: "pointer", mr: 1 }}
                  src={PRINTicon}
                  variant="avatar"
                />
                <span>Add PRINT asset to wallet</span>
              </Flex>
              <Flex
                sx={{ alignItems: "stretch", justifyContent: "space-between" }}
              >
                <Heading
                  sx={{ fontSize: 1, pr: [1, 2] }}
                  onClick={() => copyClipboard("PRINT", addresses["lqtyToken"])}
                >
                  <Icon name="clipboard" size="2x" />
                </Heading>
                <Button
                  onClick={addTokenToWallet(
                    "PRINT",
                    addresses["lqtyToken"],
                    PRINTicon
                  )}
                  sx={{ height: "30px", width: "70px" }}
                >
                  Add
                </Button>
              </Flex>
            </Flex>
          </Box>
        </Box>
      </Card>
    </>
  );
};
